import type { Locale } from '@jws/shared';
import { computed, ref } from 'vue';

const urlLocale = new URLSearchParams(window.location.search).get('lang');
const storedLocale = window.localStorage.getItem('jws.locale');
const localHost = ['127.0.0.1', 'localhost'].includes(window.location.hostname);
const initialLocale: Locale = urlLocale === 'en-US' || urlLocale === 'zh-CN'
  ? urlLocale
  : storedLocale === 'en-US' || storedLocale === 'zh-CN'
    ? storedLocale
    : window.location.hostname.endsWith('.cn') || localHost ? 'zh-CN' : 'en-US';

export const locale = ref<Locale>(initialLocale);
export const isZh = computed(() => locale.value === 'zh-CN');
document.documentElement.lang = initialLocale;

export function text(zh: string, en: string): string {
  return isZh.value ? zh : en;
}

export function toggleLocale(): void {
  locale.value = isZh.value ? 'en-US' : 'zh-CN';
  document.documentElement.lang = locale.value;
  window.localStorage.setItem('jws.locale', locale.value);
  const url = new URL(window.location.href);
  url.searchParams.set('lang', locale.value);
  window.history.replaceState(window.history.state, '', url);
}

export function formatDate(value: string | null): string {
  if (!value) return '';
  return new Intl.DateTimeFormat(isZh.value ? 'zh-CN' : 'en-US', {
    year: 'numeric', month: '2-digit', day: '2-digit'
  }).format(new Date(value));
}
